import React, { useEffect, useState } from 'react'
import iconImg from "../assets/myportal-icon.png"
import UseChaseProvider from '../utils/use-chase-provider'

interface IMessageDisplayCard { showReply?: boolean }

const MessageDisplayCard: React.FC<IMessageDisplayCard> = ({ showReply = false }) => {
    const { chase, ToggleMessage } = UseChaseProvider()
    let { chaseItem: chaseItems } = chase!
    const [message, setMessage] = useState<string | undefined>(undefined)

    chase?.drivers?.map((item) => {
        chaseItems = [...chaseItems, ...item.chaseItem]
    })


    useEffect(() => {
        if (chase?.messages[0]?.message && chase?.messages[0]?.type === "dashboard") {
            setMessage(chase?.messages[0]?.message)
        }
        else if (chaseItems.filter((chaseItem) => chaseItem.status === "Awaiting-Customer").length) {
            setMessage("Your Insurer has requested certain information to validate your policy. Providing the information is very easy. Simply submit the requested information from the list below. It will only take 2 minutes ​🚀​")

        } else if (chaseItems.filter((chaseItem) => chaseItem.status === "Pending-Review").length && !chaseItems.filter((chaseItem) => chaseItem.status === "Awaiting-Customer").length) {
            setMessage("Thank you for your submission. The information you have provided us is currently being reviewed by our team. This typically takes 24-72 hours. We will update you shortly ⏳​")

        } else if (chaseItems.filter((chaseItem) => chaseItem.status === "Approved").length === chaseItems.length) {
            setMessage("Our team has approved the information you’ve provided. Thank you for your cooperation, you’re all set. Safe travels ✅")
        }

    }, [chaseItems, chase])

    return (
        <>
            {message && <div className="w-full mt-9 rounded-card bg-[rgba(124,92,255,0.10)] border border-[rgba(124,92,255,0.30)] px-5 pb-5 pt-11 relative animate-fade-in">
                <div className='absolute top-[-30px] left-1/2 -translate-x-1/2 w-[60px] h-[60px]'>
                    <span className='absolute -inset-5 rounded-full bg-[radial-gradient(circle,rgba(168,85,247,0.45),rgba(255,94,188,0.12)_55%,transparent_72%)]' aria-hidden />
                    <span className='absolute inset-0 rounded-full border-2 border-[rgba(168,85,247,0.65)] animate-pulse-ring' aria-hidden />
                    <span className='absolute inset-0 rounded-full border-2 border-[rgba(168,85,247,0.65)] animate-pulse-ring [animation-delay:1.2s]' aria-hidden />
                    <div className='relative w-full h-full rounded-full bg-[#0D1530] ring-[3px] ring-app-panel shadow-[0_8px_22px_-6px_rgba(168,85,247,0.8)] flex items-center justify-center overflow-hidden'>
                        <img src={iconImg} alt="" className='w-full h-full object-cover scale-[1.12]' />
                    </div>
                </div>

                <p className="text-[15px] leading-[24px] text-center text-white/[0.85]">{message}​</p>

                {showReply && <div className='flex justify-center mt-3'><button type='button' onClick={ToggleMessage} className='h-9 px-5 rounded-full text-button text-app-link bg-[rgba(63,102,255,0.15)] hover:bg-[rgba(63,102,255,0.25)] active:scale-[0.96] transition-[background-color,transform] duration-[120ms]'>Reply</button></div>}
            </div>}
        </>
    )
}

export default MessageDisplayCard
